import type { SxProps } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { formatDistanceToNow } from 'date-fns';

import type { JSX } from 'react';

interface DateCellProps {
  date?: string | null;
  sx?: SxProps;
}

export function DateCell(props: DateCellProps): JSX.Element {
  if (!props.date) {
    return <Typography component="span">N / A</Typography>;
  }

  const date = new Date(props.date);
  const formattedDate = formatDistanceToNow(date, { addSuffix: true, includeSeconds: true });

  return (
    <Tooltip title={date.toLocaleString()}>
      <Typography component="span" sx={props.sx}>
        {formattedDate}
      </Typography>
    </Tooltip>
  );
}
